<template>
  <main class="container my-5">
    <div class="mt-3">
      <ul class="list-group text-muted px-3">
        <li
          class="list-group-item px-4 d-flex justify-content-between align-items-center"
          style="border-top-width: 1px;"
        >
          <strong>
            <span>Selecione um meio de pagamento</span>
          </strong>
        </li>
        <li
          v-for="(item, index) in plano.metodoPagamento"
          :key="index"
          class="list-group-item px-4 d-flex justify-content-between align-items-center"
          style="border-top-width: 1px;"
        >
          <div class="col-1">
            <input
              type="radio"
              name="formaPagamento"
              :value="item"
              v-model="plano.modeloCobranca"
              @change="recalcular()"
              id="flexRadioDefault1"
            />
          </div>

          <div class="col-5">
            <span class="text-left">
              <strong>{{ item.label }}</strong>
            </span>
          </div>
          <div class="col-4">
            <span class="text-left">
              <small>
                Cobrança {{ formatPeriodicidade(item.periodicidade) }}
              </small>
            </span>
          </div>

          <div class="col-2 text-right icon-pagamento">
            <i :class="item.icon"></i>
          </div>
        </li>
      </ul>
    </div>
    <div
      v-if="erro"
      class="card my-2 badge-danger text-center p-3 text-uppercase m-3"
    >
      {{ erro.title }}
    </div>

    <div
      class="mt-3 mb-5 px-3 col-12 d-flex flex-column flex-lg-row justify-content-between"
    >
      <button
        class="btn btn_color_system px-5 mt-4 py-2"
        @click="$router.go(-1)"
      >
        VOLTAR
      </button>
      <button
        class="btn btn_color_system py-2 px-5 mt-4"
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#exampleModal"
      >
        CONTINUAR
      </button>
    </div>
    <div class="row d-flex text-center">
      <div class="col-12 m-2 text-center">
        <span><strong>Valor do plano</strong></span>
        <br />
        <span class="valor-plano">
          R$ {{ formatPrice(plano.valorMensal) }} /{{
            plano.modeloCobranca.periodicidade
          }}
        </span>
        <br />
      </div>
    </div>

    <Loading v-if="loading"></Loading>

    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-full">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Termos e condições
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div class="modal-body">
            <div class="modal-body-full" v-html="this.plano.termos"></div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary btn_color_system"
              @click="contratarPlano()"
              data-bs-dismiss="modal"
            >
              Aceitar
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/Loading.vue'
import { APIService } from '../../APIService'
import { SimuladorService } from '../../service/assinatura/SimuladorService'

const apiService = new APIService()
const simuladorService = new SimuladorService()

export default {
  name: 'CheckoutAssinatura',
  props: [],
  components: { Loading },
  data() {
    return {
      loading: false,
      plano: this.$store.state.simulacaoPlano,
      erro: null,
    }
  },
  mounted() {},
  methods: {
    formatPrice(value) {
      let val = ((value || 0) / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    recalcular() {
      simuladorService.calcularValorParcelas(this.plano)
    },
    formatPeriodicidade(periodicidade) {
      return simuladorService.formatPeriodicidade(periodicidade)
    },
    contratarPlano() {
      if(this.plano.modeloCobranca.formaPagamento == 'BOLETO') {
        this.$router.push({
          path: `/planos/checkout/endereco/${this.plano.planoId}/${this.plano.recorrenciaId}`,
          query: {
            nextUrl: `/planos/checkout/boleto/${this.plano.planoId}/${this.plano.recorrenciaId}`,
          },
        })
        return;
      }

      this.loading = true
      apiService
        .contratarPlano(this.plano)
        .then((res) => {
          this.plano = res
          if (this.plano.modeloCobranca.formaPagamento == 'PIX') {
            this.$router.push({
              path: `/planos/checkout/endereco/${this.plano.planoId}/${this.plano.recorrenciaId}`,
              query: {
                nextUrl: `/planos/checkout/pix/${this.plano.planoId}/${this.plano.recorrenciaId}`,
              },
            })
          } else if (this.plano.modeloCobranca.formaPagamento == 'BOLETO') {
            this.$router.push({
              path: `/planos/checkout/endereco/${this.plano.planoId}/${this.plano.recorrenciaId}`,
              query: {
                nextUrl: `/planos/checkout/boleto/${this.plano.planoId}/${this.plano.recorrenciaId}`,
              },
            })
          } else {
            this.$router.push({
              path: `/planos/checkout/endereco/${this.plano.planoId}/${this.plano.recorrenciaId}`,
              query: {
                nextUrl: `/planos/checkout/cartao-credito/${this.plano.planoId}/${this.plano.recorrenciaId}`,
              },
            })
          }
          this.loading = false
        })
        .catch((error) => {
          this.erro = error.response.data
        })
        .finally(() => (this.loading = false))
    },
    goToStep(step) {
      this.$emit("goToStep", step);
    },
    aceiteTermos() {
      this.$swal({
        title: 'Termos e condições',
        html: `<div class="modal-xl" style="overflow: auto;max-height: 80vh;">${this.plano.termos}</div>`,
        confirmButtonText: 'Aceitar',
        cancelButtonText: 'Cancelar',
        showCancelButton: true,
      }).then((res) => {
        if (res.isConfirmed) {
          this.contratarPlano()
        }
      })
    },
  },
}
</script>

<style scoped>
.btn-simulador {
  color: whitesmoke;
  border: 0.1cm;
}

hr {
  border: 0;
  display: flex;
  flex: 1;
  background: var(--cor-secundaria);
  height: 2px;
  position: relative;
}

.titulo {
  color: var(--cor-principal);
  font-size: 1rem;
  margin: 0 8px;
}

.icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 36px;
  transition: 0.5s;
  color: var(--cor-secundaria);
  overflow: hidden;
}

.icon-pagamento {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  transition: 0.5s;
  color: var(--cor-secundaria);
  overflow: hidden;
}

.custom-range::-ms-thumb {
  background-color: var(--cor-secundaria);
}

.custom-range::-webkit-slider-thumb {
  background-color: var(--cor-secundaria);
}

.custom-range::-moz-range-thumb {
  background-color: var(--cor-secundaria);
}

.align-item {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.v-line {
  border-right: 1px solid;
  border-left: 1px solid;
}

.cor-principal {
  color: var(--cor-principal);
}

.valor-cobertura {
  color: var(--cor-principal);
  font-size: 24px;
  font-weight: bold;
}

.valor-contribuicao {
  color: var(--cor-principal);
  font-size: 18px;
  font-weight: bold;
}

.card-item {
  border: 0px solid;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.03);
  box-shadow: 10px 5px 5px rgba(0, 0, 0, 0.08);
}
</style>
